<template>
  <div class="restRoom">
    <ld-header>
      休息室
    </ld-header>
    <!-- <ld-navbar>
      <van-search
        placeholder="请输入休息室名称"
        maxlength="10"
        shape="round"
        clearable
        v-model.lazy="keyword"
        @search="search"
        @clear="items = [] && clearSearch()"
        @blur.prevent="changeBlur"
      />
    </ld-navbar> -->

    <div>
      <van-row
        type="flex"
        align="center"
        class="bg-white"
      >
        <van-col span="6">
          <van-dropdown-menu>
            <van-dropdown-item
              v-model="param.productType"
              :options="productTypeData"
              @change="changeProductType"
            />
          </van-dropdown-menu>
        </van-col>
        <van-col
          span="6"
          class="text-center"
          @click="toggle"
        >
          <span
            v-if="param.serverAirportName"
            class="main-color"
          >{{ param.serverAirportName }}</span>
          <span v-else>{{ (param.productType==1?'选择机场':'选择火车站') }}</span>
        </van-col>
        <van-col
          span="6"
          class="text-center"
          @click="sortType"
        >
          价格
          <ld-icon
            type="icondown2"
            size="10"
            class="vertical-middle"
            v-show="param.sortType==2"
          />
          <ld-icon
            type="iconup1"
            size="10"
            class="vertical-middle"
            v-show="param.sortType==1"
          />
        </van-col>
        <van-col span="6">
          <van-dropdown-menu>
            <van-dropdown-item
              title="筛选"
              ref="item"
              class="filter-panel"
              :title-class="1? 'main-color' : ''"
            >
              <van-cell
                :border="false"
                v-show="terminalData.list.length"
              >
                <div class="list gray">
                  {{ terminalData.typeName }}
                </div>
                <van-row gutter="8">
                  <van-col
                    span="8"
                    v-for="(item,index1) in terminalData.list"
                    :key="index1"
                    @click="checkedItem(item)"
                    class="list"
                  >
                    <a
                      class="item-3"
                      :class="{ 'active main-color': item.checked }"
                    >{{ item.name }}</a>
                  </van-col>
                </van-row>
              </van-cell>
              <van-cell :border="false">
                <div class="list gray">
                  {{ leaveTypeData.typeName }}
                </div>
                <van-row gutter="8">
                  <van-col
                    span="8"
                    v-for="(item,index1) in leaveTypeData.list"
                    :key="index1"
                    @click="checkedItem(item)"
                    class="list"
                  >
                    <a
                      class="item-3"
                      :class="{ 'active main-color': item.checked }"
                    >{{ item.name }}</a>
                  </van-col>
                </van-row>
              </van-cell>

              <van-cell :border="false">
                <div class="list gray">
                  {{ securityCheckData.typeName }}
                </div>
                <van-row gutter="8">
                  <van-col
                    span="8"
                    v-for="(item,index1) in securityCheckData.list"
                    :key="index1"
                    @click="checkedItem(item)"
                    class="list"
                  >
                    <a
                      class="item-3"
                      :class="{ 'active main-color': item.checked }"
                    >{{ item.name }}</a>
                  </van-col>
                </van-row>
              </van-cell>

              <div class="filter-panel__reset">
                <a
                  class="reset"
                  @click="resetItems"
                >{{ $t('Reset','重置') }}</a>
                <a
                  class="selection bg-main"
                  @click="filter"
                >{{ $t('Display','显示结果') }}</a>
              </div>
            </van-dropdown-item>
          </van-dropdown-menu>
        </van-col>
      </van-row>
    </div>

    <!--  -->
    <div class="wrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <div>
          <van-cell
            v-for="(info,index) in roomList"
            :key="index"
            @click="selected(info)"
          >
            <van-row
              gutter="16"
              type="flex"
              align="center"
            >
              <van-col span="8">
                <van-image
                  :src="info.faceImg"
                  radius="8"
                  lazy-load
                  show-error
                  show-loading
                  class="full-width"
                  style="max-height:80px;"
                >
                  <template v-slot:loading>
                    <van-loading
                      type="spinner"
                      size="20"
                    />
                  </template>
                  <template v-slot:error>
                    加载失败
                  </template>
                </van-image>
              </van-col>
              <van-col span="16">
                <div class="font-md">
                  {{ info.loungeNameCn }}
                </div>
                <van-row>
                  <van-col span="18">
                    {{ info.international==1?'国内出发':'国际出发' }}
                  </van-col>
                  <van-col span="6">
                    <div class="font-lg money-color text-right text-space-1">
                      <span class="font10">&yen;</span>
                      <span class="font20 ">{{ info.salePrice }}</span>
                    </div>
                  </van-col>
                </van-row>
                <!-- <van-rate
                  v-model="value"
                  allow-half
                  readonly
                  :size="14"
                  color="#ffd21e"
                  void-icon="star"
                  void-color="#eee"
                />
                <span>  2.5 </span> -->
                <div class="gray font12">
                  <span v-show="info.terminal">{{ info.terminal }}航站楼</span>  {{ info.securityCheck==1?'安检后':'安检前' }}
                </div>
              </van-col>
            </van-row>
          </van-cell>
          <van-empty
            v-show="roomList.length==0"
          />
        </div>
      </mescroll-vue>
    </div>

    <!-- 选择城市控件 -->
    <city
      ref="city"
      @selected="changeCity"
      :city-type="cityType"
      :hot-span="hotSpan"
      :history-span="historySpan"
      :cityjczd-name="cityjczdName"
      :jczd-name="jczdName"
      :is-car="true"
    />
  </div>
</template>

<script>
import {Cell,DropdownMenu,DropdownItem,TreeSelect,Rate, Image as VanImage,loading,Search,Empty} from 'vant'
import { mapGetters } from 'vuex'
import { localget, localset } from 'Utils/storage.js'

export default {
  name: 'RestRoom',
  components: {
    [Cell.name]: Cell,
    [Rate.name]: Rate,
    [VanImage.name]: VanImage,
    [loading.name]: loading,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [TreeSelect.name]: TreeSelect,
    [Search.name]: Search,
    [Empty.name]: Empty,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    City: () => import('Common/city'),
  },
  data () {
    return {
      down:{use:false},
      param:{
        terminal:'',
        terminalName:'',
        leaveType:'',
        leaveTypeName:'',
        securityCheck:'',
        securityCheckName:'',
        productType:1,
        serverAirportCode:'PEK',
        serverAirportName:'首都国际机场',
        sortType:1
      },
      terminalData:{
        typeName: '航站楼',
        list:[]
      },
      leaveTypeData:{
        typeName: '出发类型',
        list:[{
          checked:false,
          name:'国内出发',
          value:1
        },{
          checked:false,
          name:'国际出发',
          value:2
        }]
      },
      securityCheckData:{
        typeName: '安检前后',
        list:[{
          checked:false,
          name:'安检后',
          value:1
        },{
          checked:false,
          name:'安检前',
          value:2
        }]
      },
      productTypeData: [
        { text: '机场', value: 1 },
        { text: '火车站', value: 2 },
      ],
      cityType:0,
      hotSpan:8,
      historySpan:8,
      jczdName:false,
      cityjczdName:true,
    }
  },
  computed:{
    ...mapGetters({
      travelerList: 'restRoom/travelerList',
      roomList: 'restRoom/roomList',
    }),
  },
  created () {
    try {
      let historyLog=localget('_historyLog')||{}
      if(historyLog.restRoom){
        Object.assign(this.param,historyLog.restRoom)
      }
    } catch (error) {
      console.log(error)
    }
    if(this.roomList.length==0){
      this.query()
    }
    if(this.param.productType==1){
      this.queryTerminal(this.param.serverAirportCode)
    }
  },
  methods: {
    query(){
      this.$api['airService/restRoomQuery']({
        'productType': this.param.productType,//产品类型 1 机场 2火车站
        'airTrainCode': this.param.serverAirportCode,//机场三字码或火车站点
        'terminal': this.param.terminal,//航站楼
        'leaveType': this.param.leaveType,//出发类型 1 国内出发 2 国际出发
        'securityCheck': this.param.securityCheck,//安检内外 1 安检内 2 安检外
        'pageNum': 1,
        'count': 100,
        sortType:this.param.sortType
      }).then(res=>{
        let cache=res.data||{}
        this.$store.commit('restRoom/setRoomList',cache.list||[])
      })
    },
    sortType(){
      if(this.param.sortType==1){
        this.param.sortType=2
      }else{
        this.param.sortType=1
      }
      this.query()
    },
    toggle(){
      if(this.param.productType==1){
        this.hotSpan=8
        this.historySpan=8
        this.jczdName=false
        this.cityjczdName=true
        this.cityType=0
      }else{
        this.hotSpan=6
        this.historySpan=6
        this.jczdName=true
        this.cityjczdName=false
        this.cityType=2
      }
      this.$refs.city.toggle()
    },
    selected(info){
      this.param.id=info.id
      this.$store.commit('restRoom/params',this.param)
      try {
        let historyLog=localget('_historyLog')||{}
        historyLog.restRoom=this.param
        localset('_historyLog',historyLog)
      } catch (error) {
        console.log(error)
      }
      this.$store.commit('restRoom/searchInfo',info)
      this.$router.push('/restRoom/confirm')
    },
    changeCity (info) {
      this.param.cityName=info.cityName
      this.param.serverAirportName=info.jcZdName||info.zdmc
      this.param.serverAirportCode=info.jcZdCode||info.zddm
      this.queryTerminal(info.jcZdCode)
      this.query()
    },
    //查航站楼
    queryTerminal(threeCode) {
      if (threeCode&&this.productType==1) {
        this.$api['carQuery/queryApTrnInfo']({ threeCode: threeCode }).then(res => {
          let cache = res.data || []
          if (cache.length > 0) {
            cache.forEach(ele => {
              ele.name = ele.terminalName
              ele.value = ele.terminal
              ele.checked = false
            })
            this.terminalData.list = cache
          }
        })
      }
    },
    checkedItem (item) {
      item.checked = !item.checked
    },
    filter(){
      var leave=0
      this.leaveTypeData.list.forEach(item=>{
        if(item.checked){
          leave+=1
          this.param.leaveType=item.value
          this.param.leaveTypeName=item.name
        }
      })
      if(leave>1){
        this.param.leaveType=''
        this.param.leaveTypeName=''
      }
      var security=0
      this.securityCheckData.list.forEach(item=>{
        if(item.checked){
          security+=1
          this.param.securityCheck=item.value
          this.param.securityCheckName=item.name
        }
      })
      if(security>1){
        this.param.securityCheck=''
        this.param.securityCheckName=''
      }
      var terminal=0
      this.terminalData.list.forEach(item=>{
        if(item.checked){
          terminal+=1
          this.param.terminal=item.value
          this.param.terminalkName=item.name
        }
      })
      if(terminal>1){
        this.param.terminal = ''
        this.param.terminalkName=''
      }
      this.$refs.item.toggle()
      this.query()
    },
    //重置星级
    resetItems () {
      this.leaveTypeData.list.forEach(item=>{
        item.checked=false
      })
      this.securityCheckData.list.forEach(item=>{
        item.checked=false
      })
      this.terminalData.list.forEach(item=>{
        item.checked=false
      })
      this.param.securityCheck=''
      this.param.securityCheckName=''
      this.param.leaveType=''
      this.param.leaveTypeName=''
      this.param.terminal=''
      this.param.terminalkName=''
    },
    changeProductType(){
      this.param.serverAirportName=''
      this.param.serverAirportCode=''
    },
    // 返回上一级
    back () {
      this.$store.commit('restRoom/CLEAR_ALL')
      this.$router.push({ path: '/home' })
    }
  },
  watch: {
  },
}
</script>
<style lang="less" scoped>
    @deep: ~">>>";

    @{deep}.van-dropdown-menu__bar{
        box-shadow: none;
    }
    @{deep}.van-dropdown-menu__title{
        font-size: @font-size-14;
    }
    .wrapper {
        height: calc(100vh - 140px);
        overflow: hidden;
    }
    .item-3{
        display: block;
        text-align: center;
        color: @color-text-deepGray;
        background-color: @color-background-lightGray;
        font-size: 12px;
        border-radius: 16px;
        height: 28px;
        line-height: 28px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .item-3.active {
        border: 1px solid @color-text-main;
        color:@color-text-main;
    }
    .list{
        padding-bottom: 5px;
    }
</style>
